
        import React from 'react';
        import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new SpriteSymbol({
  "id": "warning.sprite",
  "use": "warning.sprite-usage",
  "viewBox": "0 0 56 56",
  "content": "<symbol viewBox=\"0 0 56 56\" xmlns=\"http://www.w3.org/2000/svg\" id=\"warning.sprite\">\n <path d=\"m4.068 49.67h47.86c0.5523 0 1-0.4477 1-1 0-0.1759-0.04642-0.3488-0.1346-0.501l-23.93-41.34c-0.2767-0.478-0.8885-0.6411-1.366-0.3644-0.1512 0.08754-0.2768 0.2132-0.3644 0.3644l-23.93 41.34c-0.2767 0.478-0.1136 1.09 0.3644 1.366 0.1523 0.08815 0.3251 0.1346 0.501 0.1346zm26.27-7h-4.667v-4.667h4.667zm0-9.333h-4.667v-9.333h4.667z\" fill-rule=\"evenodd\" />\n</symbol>"
});
        sprite.add(symbol);

        const WarningSpriteSpriteSymbol = props => (
            <svg {...props} viewBox='0 0 56 56'>
                <use xlinkHref='#warning.sprite' />
            </svg>
        );
        export default WarningSpriteSpriteSymbol;
  